import {graphql, useFragment} from 'react-relay'

import {useRunningBuildUpdaterRelay} from '../../../../../../hooks/relay/useRunningBuildUpdaterRelay'
import {useBuildStatusIconRelay} from '../../../../../../hooks/useBuildStatusIcon'
import Routes, {getHref} from '../../../../../../routes'
import RunJob from '../../../components/RunJob/RunJob'
import {usePipelineId} from '../../../hooks/pipeline'

import type {PipelineLastRunJobFragment$key} from './__generated__/PipelineLastRunJobFragment.graphql'

type Props = {
  x: number
  y: number
  jobKey: PipelineLastRunJobFragment$key | null
  runId: string
}

const fragment = graphql`
  fragment PipelineLastRunJobFragment on Build {
    rawId
    buildType {
      name
    }
    parallelized
    status
    state
    statusText
    artifacts {
      count
    }
    snapshotDependencies {
      build {
        runningInfo {
          percentageComplete
          leftSeconds
        }
      }
    }
    runningInfo {
      percentageComplete
      leftSeconds
    }
    ...useBuildStatusIconFragment
    ...useRunningBuildUpdaterRelayFragment
  }
`

export default function PipelineLastRunJob({x, y, jobKey, runId}: Props) {
  const id = usePipelineId()
  const job = useFragment(fragment, jobKey)
  const {rawId: jobId, runningInfo} = job ?? {}
  const icon = useBuildStatusIconRelay(job)

  useRunningBuildUpdaterRelay(job)

  return (
    <RunJob
      {...job}
      jobId={jobId}
      runningInfo={{...runningInfo, elapsedSeconds: 0}}
      buildType={{...job?.buildType, name: job?.buildType?.name ?? ''}}
      icon={icon}
      to={{
        pathname: getHref(Routes.PIPELINE_RUN, {pipelineId: id, pipelineRunId: runId}),
        search: `job=${jobId}`,
      }}
      x={x}
      y={y}
    />
  )
}
